export default __webpack_public_path__ + "static/media/Banner3.0fc2be79.svg";